import { render, staticRenderFns } from "./ListDeletedSurveys.vue?vue&type=template&id=616cd97c&"
import script from "./ListDeletedSurveys.vue?vue&type=script&lang=ts&"
export * from "./ListDeletedSurveys.vue?vue&type=script&lang=ts&"
import style0 from "./ListDeletedSurveys.vue?vue&type=style&index=0&id=616cd97c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports